import { AssetType } from '@modules/src/enums/AssetType'
import { Orientation } from '@modules/src/enums/Orientation'
import { ComponentEvent } from '@modules/src/enums/ComponentEvent'
import GameSignals from '../../signals/GameSignals'
import { ScrollDirection } from '@modules/src/enums/ScrollDirection'
import { ModuleSignals } from '@modules/src/signals/ModuleSignals'
import { IComponent, ICustomEventData } from '@modules/src/interfaces/IComponents'
import { BaseContainer } from '@base/base/BaseContainer'
import { ModulesFacade } from '@modules/src/ModulesFacade'
import { ButtonState } from '@modules/src/enums/ButonStates'
import { Align } from '@modules/src/enums/Align'
import { SpriteH } from '@/utils/pixi-heaven-compat'
import { RestoreUtil } from '../../utils/RestoreUtil'
import Facade from '../../Facade'
import * as PIXI from 'pixi.js'
import { ContainersNames } from '@/containers/ContainersNames'
import { getCurrentOrientation } from '@/managers/ui/SplashScreenManager'
export const SPLASH_SCREEN_COMPONENT: IComponent = {
    name: ContainersNames.SPLASH_SCREEN_CONTAINER,
    type: AssetType.CONTAINER,
    zIndex: new Map<Orientation, number>([
        [Orientation.LANDSCAPE, 1],
        [Orientation.PORTRAIT, 1],
    ]),
    visible: false,
    events: [
        {
            event: ComponentEvent.SHOW,
            onGameSignalsTriggered: [GameSignals.displaySplashScreenState],
        },
        {
            event: ComponentEvent.DELETE,
            onGameSignalsTriggered: [GameSignals.splashScreenButtonClicked],
        },
    ],
    items: [
        {
            name: 'Overlay',
            type: AssetType.OVERLAY,
            componentStyle: {
                color: 0x00000,
                opacity: 0.5,
            },
        },
        {
            name: 'Splash Background Landscape',
            type: AssetType.SPRITE,
            src: `intro_bg_landscape.jpg`,
            visible: false,
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0,
                    y: 0,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0,
                    y: 0,
                },
            ],
            anchor: 0,
            events: [
                {
                    onGameSignalsTriggered: [ModuleSignals.gameResized, GameSignals.displaySplashScreenState],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        data.component.componentElement.visible = getCurrentOrientation() === Orientation.LANDSCAPE
                    },
                },
            ],
        },
        {
            name: 'Splash Background Portrait',
            type: AssetType.SPRITE,
            src: `intro_bg_portrait.jpg`,
            visible: false,
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0,
                    y: 0,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0,
                    y: -3.5,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1,
                    y: 1,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1,
                    y: 1,
                },
            ],
            anchor: 0,
            events: [
                {
                    onGameSignalsTriggered: [ModuleSignals.gameResized, GameSignals.displaySplashScreenState],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        data.component.componentElement.visible = getCurrentOrientation() === Orientation.PORTRAIT
                    },
                },
            ],
        },

        {
            name: 'Scroll Container',
            type: AssetType.SCROLL_CONTAINER,
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 373,
                    y: -6,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0,
                    y: 360,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0.7,
                    y: 0.7,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1,
                    y: 1,
                },
            ],
            scrollSettings: {
                autoScroll: true,
                maskSize: [
                    {
                        orientation: Orientation.LANDSCAPE,
                        width: 1920,
                        // compensa la scala 0.8 del container e aggiunge margine verticale
                        height: 1380,
                    },
                    {
                        orientation: Orientation.PORTRAIT,
                        width: 1080,
                        height: 2100,
                    },
                ],
                scrollPageSize: new Map<Orientation, number>([
                    [Orientation.LANDSCAPE, 1920],
                    [Orientation.PORTRAIT, 1080],
                ]),
                onPageChange: (pageIndex: number) => {
                    GameSignals.splashSlideChanged.emit(pageIndex)
                },
                waitBeforeNextSlide: 3000,
                scrollDirection: ScrollDirection.RIGHT,
                buttons: {
                    nextBtn: {
                        name: 'NEXT BUTTON',
                        type: AssetType.BUTTON,
                        src: `leaf_right_off.png`,
                        events: [
                            {
                                onGameSignalsTriggered: [ModuleSignals.gameResized],
                                event: ComponentEvent.CUSTOM_NEW,
                                callback: function (
                                    data: ICustomEventData,
                                    componentData: IComponent,
                                    container: BaseContainer
                                ) {
                                    const componentElement = data.component.componentElement

                                    if (ModulesFacade.orientation === Orientation.PORTRAIT) {
                                        componentElement.position.set(740, 1000)
                                        componentElement.scale.set(0.85, 0.85)
                                    }
                                },
                            },
                        ],
                        buttonStates: [
                            {
                                state: ButtonState.POINTER_UP_OUT,
                                src: 'leaf_right_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_OUT,
                                src: 'leaf_right_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_OVER,
                                src: 'leaf_right_hover.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_UP,
                                src: 'leaf_right_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_DOWN,
                                src: 'leaf_right_clickhover.png',
                                events: [],
                            },
                        ],
                        size: [
                            {
                                orientation: Orientation.LANDSCAPE,
                                width: 0,
                                height: 0,
                            },
                            {
                                orientation: Orientation.PORTRAIT,
                                width: 170,
                                height: 170,
                            },
                        ],
                        position: [
                            {
                                orientation: Orientation.LANDSCAPE,
                                x: 0,
                                y: 0,
                            },
                            {
                                orientation: Orientation.PORTRAIT,
                                x: 740,
                                y: 1000,
                            },
                        ],
                    },
                    prevBtn: {
                        name: 'PREV BUTTON',
                        type: AssetType.BUTTON,
                        src: `leaf_left_off.png`,
                        events: [
                            {
                                onGameSignalsTriggered: [ModuleSignals.gameResized],
                                event: ComponentEvent.CUSTOM_NEW,
                                callback: function (
                                    data: ICustomEventData,
                                    componentData: IComponent,
                                    container: BaseContainer
                                ) {
                                    const componentElement = data.component.componentElement

                                    if (ModulesFacade.orientation === Orientation.PORTRAIT) {
                                        componentElement.position.set(180, 1000)
                                        componentElement.scale.set(0.85, 0.85)
                                    }
                                },
                            },
                        ],
                        buttonStates: [
                            {
                                state: ButtonState.POINTER_UP_OUT,
                                src: 'leaf_left_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_OUT,
                                src: 'leaf_left_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_OVER,
                                src: 'leaf_left_hover.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_UP,
                                src: 'leaf_left_off.png',
                                events: [],
                            },
                            {
                                state: ButtonState.POINTER_DOWN,
                                src: 'leaf_left_clickhover.png',
                                events: [],
                            },
                        ],
                        size: [
                            {
                                orientation: Orientation.LANDSCAPE,
                                width: 0,
                                height: 0,
                            },
                            {
                                orientation: Orientation.PORTRAIT,
                                width: 170,
                                height: 170,
                            },
                        ],
                        position: [
                            {
                                orientation: Orientation.LANDSCAPE,
                                x: 0,
                                y: 0,
                            },
                            {
                                orientation: Orientation.PORTRAIT,
                                x: 180,
                                y: 1000,
                            },
                        ],
                    },
                },
            },
            items: [
                {
                    name: 'First Item',
                    type: AssetType.CONTAINER,
                    position: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            x: 210,
                            y: 0,
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            x: 0,
                            y: 0,
                        },
                    ],
                    items: [
                        {
                            name: 'Image',
                            type: AssetType.SPRITE,
                            src: `slide_1.png`,
                            anchor: 0,
                            scale: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 1,
                                    y: 1,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 0.75,
                                    y: 0.75,
                                },
                            ],
                        },
                        {
                            name: 'Message',
                            type: AssetType.SPRITE,
                            src: `slide_text_1.png`,
                            anchor: 0.5,
                            position: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 95.5,
                                    y: 1228,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 163.5,
                                    y: 1000,
                                },
                            ],
                            scale: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 1,
                                    y: 1,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 0.6,
                                    y: 0.6,
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'Second Item',
                    type: AssetType.CONTAINER,
                    position: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            x: 2130,
                            y: 0,
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            x: 1080,
                            y: 0,
                        },
                    ],
                    items: [
                        {
                            name: 'Image',
                            type: AssetType.SPRITE,
                            src: `slide_2.png`,
                            anchor: 0,
                            scale: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 1,
                                    y: 1,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 0.75,
                                    y: 0.75,
                                },
                            ],
                        },
                        {
                            name: 'Message',
                            type: AssetType.SPRITE,
                            src: `slide_text_2.png`,
                            anchor: 0.5,
                            position: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 95.5,
                                    y: 1228,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 163.5,
                                    y: 1000,
                                },
                            ],
                            scale: [
                                {
                                    orientation: Orientation.LANDSCAPE,
                                    x: 1,
                                    y: 1,
                                },
                                {
                                    orientation: Orientation.PORTRAIT,
                                    x: 0.6,
                                    y: 0.6,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            name: 'Indicator Left',
            type: AssetType.SPRITE,
            src: `indicator_on.png`,
            anchor: 0.5,
            events: [
                {
                    onGameSignalsTriggered: [GameSignals.splashSlideChanged],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const pageIndex = Number(data.signalData ?? 0)
                        const target: any = data.component.componentElement
                        const isActive = pageIndex === 0
                        target.texture = PIXI.Texture.from(isActive ? 'indicator_on.png' : 'indicator_off.png')
                        target.scale.set(isActive ? 0.6 : 0.5)
                    },
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1709.5,
                    y: 1020,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 490,
                    y: 1688,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0.6,
                    y: 0.6,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1,
                    y: 1,
                },
            ],
        },
        {
            name: 'Indicator Right',
            type: AssetType.SPRITE,
            src: `indicator_off.png`,
            anchor: 0.5,
            events: [
                {
                    onGameSignalsTriggered: [GameSignals.splashSlideChanged],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const pageIndex = Number(data.signalData ?? 0)
                        const target: any = data.component.componentElement
                        const isActive = pageIndex === 1
                        target.texture = PIXI.Texture.from(isActive ? 'indicator_on.png' : 'indicator_off.png')
                        target.scale.set(isActive ? 0.6 : 0.5)
                    },
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1784.5,
                    y: 1020,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 590,
                    y: 1688,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0.5,
                    y: 0.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1,
                    y: 1,
                },
            ],
        },
        {
            name: 'Play Anywhere Text',
            type: AssetType.TEXT,
            translationKey: 'CLICK ANYWHERE TO PLAY',
            anchor: 0.5,
            textStyle: [
                {
                    orientation: Orientation.LANDSCAPE,
                    options: {
                        fill: 0xffffff,
                        fontFamily: 'Montserrat',
                        align: 'center',
                        fontSize: 50,
                        fontWeight: '900',
                    },
                },
                {
                    orientation: Orientation.PORTRAIT,
                    options: {
                        fill: 0xffffff,
                        fontFamily: 'Montserrat',
                        align: 'center',
                        fontSize: 46,
                        fontWeight: '900',
                    },
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 685.042,
                    y: 1009,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: Align.CENTER,
                    y: 1598,
                },
            ],
            events: [
                {
                    onGameSignalsTriggered: [GameSignals.displaySplashScreenState],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const textComponent: any = data.component.componentElement
                        textComponent.interactive = true
                        textComponent.buttonMode = true
                        textComponent.cursor = 'pointer'
                        textComponent.hitArea = new PIXI.Rectangle(-2000, -2000, 4000, 4000)
                        textComponent.alpha = 1
                        textComponent.__splashFadeDirection = -1

                        const pulseCallback = () => {
                            const speed = 0.025
                            textComponent.alpha += textComponent.__splashFadeDirection * speed

                            if (textComponent.alpha <= 0) {
                                textComponent.alpha = 0
                                textComponent.__splashFadeDirection = 1
                            } else if (textComponent.alpha >= 1) {
                                textComponent.alpha = 1
                                textComponent.__splashFadeDirection = -1
                            }
                        }

                        const onClickAnywhere = () => {
                            GameSignals.splashScreenButtonClicked.emit()
                        }

                        if (textComponent.__splashPulseCallback) {
                            PIXI.Ticker.shared.remove(textComponent.__splashPulseCallback)
                        }
                        if (textComponent.__splashClickHandler) {
                            textComponent.off('pointertap', textComponent.__splashClickHandler)
                        }

                        textComponent.__splashPulseCallback = pulseCallback
                        textComponent.__splashClickHandler = onClickAnywhere

                        PIXI.Ticker.shared.add(pulseCallback)
                        textComponent.on('pointertap', onClickAnywhere)
                    },
                },
                {
                    onGameSignalsTriggered: [GameSignals.splashScreenButtonClicked],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const textComponent: any = data.component.componentElement
                        if (textComponent.__splashPulseCallback) {
                            PIXI.Ticker.shared.remove(textComponent.__splashPulseCallback)
                        }
                        if (textComponent.__splashClickHandler) {
                            textComponent.off('pointertap', textComponent.__splashClickHandler)
                        }
                    },
                },
            ],
        },

        // {
        //     name: 'Play Button',
        //     type: AssetType.BUTTON,
        //     src: `harrow_off.png`,
        //     buttonStates: [
        //         {
        //             state: ButtonState.POINTER_OUT,
        //             src: 'harrow_off.png',
        //             events: [],
        //         },
        //         {
        //             state: ButtonState.POINTER_OVER,
        //             src: 'harrow_hover.png',
        //             events: [],
        //         },
        //         {
        //             state: ButtonState.POINTER_UP,
        //             src: 'harrow_hover.png',
        //             events: [
        //                 {
        //                     event: ComponentEvent.TRIGGER_SIGNAL,
        //                     signalsToTrigger: [GameSignals.splashScreenButtonClicked],
        //                 },
        //             ],
        //         },
        //         {
        //             state: ButtonState.POINTER_DOWN,
        //             src: 'harrow_on.png',
        //             events: [],
        //         },
        //     ],
        //     size: [
        //         {
        //             orientation: Orientation.LANDSCAPE,
        //             width: 237.19,
        //             height: 117.87,
        //         },
        //         {
        //             orientation: Orientation.PORTRAIT,
        //             width: 194,
        //             height: 100,
        //         },
        //     ],
        //     position: [
        //         {
        //             orientation: Orientation.LANDSCAPE,
        //             x: 938,
        //             y: 957,
        //         },
        //         {
        //             orientation: Orientation.PORTRAIT,
        //             x: Align.CENTER,
        //             y: 1598,
        //         },
        //     ],
        // },

        {
            name: 'Game Logo',
            type: AssetType.SPRITE,
            src: `logo.png`,
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: -11.5,
                    y: 112,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 335,
                    y: 130,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0.7,
                    y: 0.7,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0.5,
                    y: 0.5,
                },
            ],
        },
        {
            name: 'Checkbox Container',
            type: AssetType.CONTAINER,
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: -94,
                    y: 986,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: Align.CENTER,
                    y: 1769,
                },
            ],
            items: [
                {
                    name: 'CheckBox',
                    type: AssetType.SPRITE,
                    src: `indicator_off.png`,
                    scale: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            x: 0.5,
                            y: 0.5,
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            x: 0.5,
                            y: 0.5,
                        },
                    ],
                    position: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            x: 122,
                            y: 35.5,
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            x: 13.5,
                            y: 42.5,
                        },
                    ],
                    events: [
                        {
                            event: ComponentEvent.CUSTOM,
                            onGameSignalsTriggered: [GameSignals.displaySplashScreenState],
                            callback: function (componentData: IComponent, component: SpriteH) {
                                ;(component as any).buttonMode = true
                                component.interactive = true

                                let checked: number = +RestoreUtil.getKeyData(RestoreUtil.SKIP_INTRO_KEY)
                                if (checked) {
                                    GameSignals.splashScreenButtonClicked.emit()
                                    return
                                }

                                component.on('click', () => {
                                    if (checked) {
                                        component.texture = PIXI.Texture.from(`indicator_off.png`)
                                        checked = 0
                                    } else {
                                        component.texture = PIXI.Texture.from(`indicator_on.png`)
                                        checked = 1
                                    }
                                    GameSignals.skipIntroToggled.emit(checked == 1)
                                })
                                component.on('touchend', () => {
                                    if (checked) {
                                        component.texture = PIXI.Texture.from(`indicator_off.png`)
                                        checked = 0
                                    } else {
                                        component.texture = PIXI.Texture.from(`indicator_on.png`)
                                        checked = 1
                                    }
                                    GameSignals.skipIntroToggled.emit(checked == 1)
                                })
                            },
                        },
                    ],
                },
                {
                    name: 'CheckBox Text',
                    type: AssetType.TEXT,
                    translationKey: "Don't show again",
                    textStyle: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            options: {
                                fill: 0xffffff,
                                fontFamily: 'Montserrat',
                                align: 'center',
                                fontSize: 32,
                                wordWrap: true,
                                wordWrapWidth: 460,
                            },
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            options: {
                                fill: 0xffffff,
                                fontFamily: 'Montserrat',
                                align: 'center',
                                fontSize: 42,
                                wordWrap: true,
                                wordWrapWidth: 460,
                            },
                        },
                    ],
                    position: [
                        {
                            orientation: Orientation.LANDSCAPE,
                            x: 77.5,
                            y: 37.5,
                        },
                        {
                            orientation: Orientation.PORTRAIT,
                            x: 30.5,
                            y: 37.5,
                        },
                    ],
                },
            ],
        },
    ],
}
